/**
 * Bi-roue de synastrie — le DESSIN, et rien d'autre.
 *
 * Le serveur calcule les deux thèmes et leurs aspects croisés, et les dépose dans un
 * <script type="application/json"> porté par la page (cf. views/tools/synastry/result.jsp). Ce
 * module les lit et trace. Aucun appel réseau : ce qui est affiché vient d'être calculé, le
 * redemander serait un aller-retour pour rien.
 *
 * Il orchestrait auparavant TOUT le calcul depuis le navigateur — deux POST à l'outil thème astral
 * puis un troisième ici — si bien que l'outil ne répondait rien sans JavaScript et qu'une landing
 * ne pouvait pas l'héberger. Le calcul est reparti au serveur ; il ne reste que ce qu'une feuille de
 * style ne sait pas faire, à savoir peindre un canevas.
 *
 * PAS la classe `.sky-chart` sur le conteneur : sky-chart/index.js l'auto-instancie en roue SIMPLE
 * à partir du premier <script> trouvé, et rendrait ici le seul thème A. D'où un crochet propre,
 * `data-synastry-chart`.
 */
import { SynastryChart } from '../sky-chart/core/SynastryChart.js';

function attach(box) {
	const source = box.querySelector('script[type="application/json"]');
	const canvas = box.querySelector('canvas');
	if (!source || !canvas) return;

	try {
		const data = JSON.parse(source.textContent);
		if (!data.chartA || !data.chartB) return;
		new SynastryChart(canvas, data.chartA, data.chartB, data.crossAspects || []);
	} catch (error) {
		// La page reste utile sans la roue : les contacts et le tableau sont rendus par le serveur.
		console.error("Erreur lors de l'initialisation de la bi-roue de synastrie:", error);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-synastry-chart]').forEach(attach);
});
